import React from "react";
import labels from "../../../helpers/labels.json";
import { Header } from "../../internal/Header/Header";

const Index = ({ children }) => {
  return (
    <Header showSidebar selectedItem={labels.notice_generation}>
      {children}
    </Header>
  );
};

export default Index;
